import http from '../../utils/http';

/**
 * 上传单个文件
 * @param {File} file - 要上传的文件
 * @param {Object} params - 其他参数
 * @returns {Promise}
 */
export function uploadFile(file, params = {}) {
  const formData = new FormData();
  formData.append('file', file);
  
  // 添加其他参数
  Object.keys(params).forEach(key => {
    formData.append(key, params[key]);
  });
  
  return http.post('/file/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: function (progressEvent) {
      // Do whatever you want with the native progress event
      if (progressEvent.lengthComputable) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log('Upload progress:', percentCompleted);
        // Here you can update your UI to show progress
      }
    }
  });
}

/**
 * 上传多个文件
 * @param {Array<File>} files - 要上传的文件数组
 * @param {Object} params - 其他参数
 * @returns {Promise}
 */
export function uploadFiles(files, params = {}) {
  const formData = new FormData();
  
  // 添加文件
  files.forEach(file => {
    formData.append('files[]', file);
  });
  
  // 添加其他参数
  Object.keys(params).forEach(key => {
    formData.append(key, params[key]);
  });
  
  return http.post('/file/uploads', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 获取文件上传进度
 * @param {string} uploadId - 上传ID
 * @returns {Promise}
 */
export function getUploadProgress(uploadId) {
  return http.get('/file/upload/progress', { uploadId });
}

/**
 * 获取反馈状态
 * @param {string} fileId - 文件ID
 * @returns {Promise}
 */
export function getFeedbackStatus(fileId) {
  return http.get('/get-feedback-status', { fileId });
}

/**
 * 下载文件
 * @param {string} fileId - 文件ID
 * @returns {Promise}
 */
export function downloadAiReport(fileId) {
  return http.get('/download-ai-report', { 
    fileId,
    responseType: 'blob'  // 关键：指定响应类型为blob
  });
}

/**
 * 下载反馈文件
 * @param {string} feedbackId - 反馈文件ID
 * @returns {Promise}
 */
export function downloadFeedback(feedbackId) {
  return http.get('/download-feedback', {
    feedbackId,
    responseType: 'blob'  // 关键：指定响应类型为blob
  });
}